<script lang="ts">
  import DashboardLayout from '../DashboardLayout.svelte';
  import DashHero from '../shared/DashHero.svelte';
  import OpenCuentasWidget from '../widgets/OpenCuentasWidget.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import { Cuentas } from '../../../lib/api';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let abiertas = $state(0);

  async function cargar() {
    const all = await Cuentas.list();
    abiertas = all.filter(c => c.estado === 'ABIERTA' || !c.estado).length;
  }

  const actions = [
    { id: 'cuentas', label: 'Cobrar', icon: '💳' },
    { id: 'farmaciaPos', label: 'POS', icon: '💊' },
  ];

  $effect(() => { cargar(); const t = setInterval(cargar, 45000); return () => clearInterval(t); });
</script>

<DashboardLayout title="Caja y cobros" variant="caja">
  <DashHero emoji="💳" title="Caja y cobros" subtitle="Cuentas abiertas y punto de venta farmacia" variant="caja" />
  <QuickActions {actions} onAction={onNavigate} />

  <div class="dash-kpis">
    <div class="dash-kpi"><div class="dash-kpi-label">Cuentas abiertas</div><div class="dash-kpi-value">{abiertas}</div></div>
  </div>

  <div class="dash-grid">
    <div class="col-12"><OpenCuentasWidget limit={12} /></div>
  </div>
</DashboardLayout>
